import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { StarFill } from "react-bootstrap-icons";
import playBtn from "../../../assets/images/play-btn.svg";
import LydiaNyambura from "../../../assets/images/Lydia_Nyambura.jpeg";
import SumanPaul from "../../../assets/images/Suman_Paul.jpg";
import BeckySekyere from "../../../assets/images/Becky_Sekyere.jpg";
import SarikaDubey from "../../../assets/images/Sarika_Dubey.jpg";
import MelissaOti from "../../../assets/images/Melissa_Oti.jpg";
import NobueKhumalo from "../../../assets/images/Nobue_Khumalo.png";
import {  Navigation } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

const AboutCustomers = () => {
  const [show, setShow] = useState(false);
  const vidRef = useRef<any>(null);
  const handleClose = () => setShow(false);
  const handleShow = (src) => {
    setVideoSrc(src);
    setShow(true);
  };
  const [videoSrc, setVideoSrc] = useState();

  const testimonials = [
    {
      name: "Becky Sekyere",
      img: BeckySekyere,
      country: "Ghana",
      text: "So easy to install to my phone. I tried sending money to my friend who was bereaved and he told me he got it instantly after I sent it while we were chatting.",
      video:
        "https://ileeroremit.s3.eu-west-2.amazonaws.com/customer-videos/Fast+and+Easy+Way+to+send+Money+Home+from+UK+to+Ghana+(2).mp4",
    },
    {
      name: "Suman Paul",
      img: SumanPaul,
      country: "India",
      text: "Ileero remit offers the best exchange rate, all major Indian banks are supported with recipient validation and the transfers are done instantly.",
      video:
        "https://ileeroremit.s3.eu-west-2.amazonaws.com/customer-videos/How+to+Transfer+Money+from+UK+to+India+without+charges.mp4",
    },
    {
      name: "Lydia Nyambura",
      img: LydiaNyambura,
      country: "Kenya",
      text: "What I like about Ileero Remit is that it is quite fast & efficient. Every pound counts for me & I received £2.99 in addition to what I was sending.",
      video:
        "https://ileeroremit.s3.eu-west-2.amazonaws.com/customer-videos/Lydia+Kenya+%E2%80%91+Made+with+FlexClip.mp4",
    },
    {
      name: "Sarika Dubey",
      img: SarikaDubey,
      country: "India",
      text: "The things that I liked about the Ileero app is that they offer the best conversion rate to India, transfers are done instantly and they also offer multiple payment delivery methods.",
      video:
        "https://ileeroremit.s3.eu-west-2.amazonaws.com/customer-videos/Sarika_Dubey_India.mp4",
    },
    {
      name: "Melissa Oti",
      img: MelissaOti,
      country: "Nigeria",
      text: "Myself and my family uses the Ileero remit app and what I like about the app is that it’s reliable, secure, very easy to use, there are no hidden charges and it offers the best exchange rates.",
      video:
        "https://ileeroremit.s3.eu-west-2.amazonaws.com/customer-videos/Melissa_Oti_Nigeria.mp4",
    },
    {
      name: "Nobue Khumalo",
      img: NobueKhumalo,
      country: "South Africa",
      text: "I have tried it and I can say for a fact that it is super quick, super easy and it is super convenient. If you are looking for an easy, fast and NO-FEE way of sending money to South Africa, this is the platform for you!!",
      video:
        "https://ileeroremit.s3.eu-west-2.amazonaws.com/customer-videos/Nobue_Khumalo_South+Africa.mp4",
    },
  ];

  return (
    <>
      <div className="about-customer p-4">
        <div className="text-center font-weight-bold ">
          <h1 className="col-md-4 col-sm-10 font-weight-bold text-center my-5 mx-auto">
            What our customers say about ileero Remit
          </h1>
        </div>
        <div className="row justify-content-center mx-auto">
          <div className="col-lg-8 p-3">
            <Swiper
              modules={[Navigation]}
              // className="p-4"
              spaceBetween={30}
              breakpoints={{
                // when window width is >= 640px
                640: {
                  width: 640,
                  slidesPerView: 1,
                },
                // when window width is >= 768px
                768: {
                  width: 768,
                  slidesPerView: 2,
                },
              }}
              navigation
            >
              {testimonials.map((testimonial) => (
                <SwiperSlide>
                  <div className="card py-5 px-4 my-3">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex">
                        <img
                          src={testimonial.img}
                          alt=""
                          height={50}
                          width={50}
                          className="rounded-circle"
                          style={{
                            objectFit: "cover",
                          }}
                        />
                        <div className="name mt-2 mx-3">
                          <p className=" font-weight-bold m-0 ">
                            {testimonial.name}
                          </p>
                          <p className="">{testimonial.country}</p>
                        </div>
                      </div>
                      <div
                        className="play-btn cursor-pointer"
                        onClick={() => handleShow(testimonial.video)}
                      >
                        <img src={playBtn} alt="" height={50} />
                      </div>
                    </div>
                    <p>{testimonial.text}</p>
                    <div className="row m-0">
                      <StarFill />
                      <StarFill />
                      <StarFill />
                      <StarFill />
                      <StarFill />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>

      {/* // Modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="border-0" closeButton></Modal.Header>

        <Modal.Body>
          <video width={"100%"} ref={vidRef} controls>
            <source src={videoSrc} type="video/mp4" />
          </video>
        </Modal.Body>
      </Modal>
      {/* // Modal */}
    </>
  );
};

export default AboutCustomers;
